import { Head, Link, useForm } from '@inertiajs/react'
import AdminLayout from '../../../components/layout/AdminLayout'
import Input from '../../../components/ui/Input'
import Select from '../../../components/ui/Select'
import Textarea from '../../../components/ui/Textarea'
import Checkbox from '../../../components/ui/Checkbox'

export default function AdminAgenciesNew({ aiToneOptions }) {
  const { data, setData, post, processing, errors } = useForm({
    agency: {
      name: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      postal_code: '',
      ai_tone: 'professional',
      ai_prompt: '',
      active: true,
    }
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    post('/admin/agencies')
  }

  const setField = (field, value) => {
    setData('agency', { ...data.agency, [field]: value })
  }

  return (
    <AdminLayout>
      <Head title="Nouvelle agence - Administration" />

      <div className="mx-auto max-w-3xl">
        {/* Header */}
        <div className="mb-8 flex items-center gap-4">
          <Link
            href="/admin/agencies"
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </Link>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Nouvelle agence</h1>
            <p className="mt-1 text-sm text-gray-600">Cr&eacute;er une nouvelle agence dans le r&eacute;seau</p>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm p-6 space-y-6">
          {/* Basic Info */}
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Informations g&eacute;n&eacute;rales</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="sm:col-span-2">
                <Input
                  label="Nom de l'agence"
                  name="name"
                  value={data.agency.name}
                  onChange={(e) => setField('name', e.target.value)}
                  error={errors['agency.name'] || errors.name}
                  required
                />
              </div>

              <Input
                label="Email"
                type="email"
                name="email"
                value={data.agency.email}
                onChange={(e) => setField('email', e.target.value)}
                error={errors['agency.email'] || errors.email}
                required
              />

              <Input
                label="T&eacute;l&eacute;phone"
                type="tel"
                name="phone"
                value={data.agency.phone}
                onChange={(e) => setField('phone', e.target.value)}
                error={errors['agency.phone'] || errors.phone}
                required
              />
            </div>
          </div>

          {/* Address */}
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Adresse</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="sm:col-span-2">
                <Input
                  label="Adresse"
                  name="address"
                  value={data.agency.address}
                  onChange={(e) => setField('address', e.target.value)}
                />
              </div>

              <Input
                label="Ville"
                name="city"
                value={data.agency.city}
                onChange={(e) => setField('city', e.target.value)}
                error={errors['agency.city'] || errors.city}
                required
              />

              <Input
                label="Code postal"
                name="postal_code"
                value={data.agency.postal_code}
                onChange={(e) => setField('postal_code', e.target.value)}
              />
            </div>
          </div>

          {/* AI Config */}
          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Configuration IA</h2>
            <div className="space-y-4">
              <Select
                label="Ton de l'IA"
                name="ai_tone"
                value={data.agency.ai_tone}
                onChange={(e) => setField('ai_tone', e.target.value)}
                options={(aiToneOptions || ['professional', 'friendly', 'casual', 'formal']).map((tone) => ({
                  value: tone,
                  label: tone.charAt(0).toUpperCase() + tone.slice(1)
                }))}
              />

              <Textarea
                label="Prompt IA personnalis&eacute;"
                name="ai_prompt"
                value={data.agency.ai_prompt}
                onChange={(e) => setField('ai_prompt', e.target.value)}
                rows={4}
                placeholder="Laisser vide pour utiliser le prompt par d&eacute;faut..."
              />
            </div>
          </div>

          {/* Active toggle */}
          <Checkbox
            label="Agence active"
            name="active"
            checked={data.agency.active}
            onChange={(e) => setField('active', e.target.checked)}
          />

          {/* Actions */}
          <div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
            <Link
              href="/admin/agencies"
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Annuler
            </Link>
            <button
              type="submit"
              disabled={processing}
              className="px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {processing ? 'Cr&eacute;ation...' : 'Cr&eacute;er l\'agence'}
            </button>
          </div>
        </form>
      </div>
    </AdminLayout>
  )
}
